import _ from "lodash";
import filter from "@/filter/filter.sub.js";
import betweenPrice from "@/components/CostManage/betweenPrice.vue"
export default {
  data() {
    return {
      periodOpen: {
        method: "",
        opend: false
      },
      selected: '',
      memberCheck: false,
      testRadio: false,
      addClass: [{
        name: "藍標",
        value: "blue"
      }],
      costListname: [{
          name: "折價",
          value: "discash"
        },
        {
          name: "折扣",
          value: "dispa"
        },
        {
          name: "指定",
          value: "setprice"
        }
      ],
      costmethod: [{
        name: "折價",
        value: "discash",
        aftername: "元"
      }, {
        name: "折扣",
        value: "dispa",
        aftername: "%"
      }, ],
      freightall: "",
      freightlist: [{
          name: "現場領取",
          value: "pickup",
        }, {
          name: "郵局宅配",
          value: "cosTransport",
          setting: {
            name: "",
            field: "postoffmoney"
          }
        },
        {
          name: "超商取貨",
          value: "shoppick",
          setting: {
            name: "",
            field: "conveniencemoney"
          }
        }, {
          name: "指定貨運",
          value: "setpick",
          setting: {
            name: "",
            field: "settingmoney"
          }
        }
      ],
      paymethodlist: [{
          name: "現金",
          value: "cash",
        }, {
          name: "轉帳／匯款",
          value: "tranmoney",
          setting: {
            name: "",
            field: "transfermoney"
          }
        },
        {
          name: "貨到付款",
          value: "afterpay",
          setting: {
            name: "",
            field: "delivery"
          }
        }, {
          name: "信用卡",
          value: "creditcard",
        }
      ],
      perioddata: {
        starttime: this.$moment(),
        throughtdate: 30,
        endtime: this.$moment().add(1, "months"),
        code: "",
        pre: "預購",
        name: "優惠第二波",
        price: {
          // discash ,  dispa ,setprice
          method: "discash",
          price: ""
        },
        remark: "",
        order: ""
      },
      offclasslist: [{
        main: "",
        matchclass: "黃標",
        offmethod: "discash",
        offnumber: "90",
      }]
    };

  },
  methods: {
    periodOpenSave() {
      const tmps = _.clone(this.thdata.period);
      if (this.periodOpen.method == "update") {
        this.perioddata.sourcedata.code = this.perioddata.code;
        this.perioddata.sourcedata.pre = this.perioddata.pre;
        this.perioddata.sourcedata.name = this.perioddata.name;
        this.perioddata.sourcedata.startdate = this.perioddata.starttime;
        this.perioddata.sourcedata.enddate = this.perioddata.endtime;
        this.perioddata.sourcedata.remark = this.perioddata.remark;
        this.perioddata.sourcedata.order = this.perioddata.order;
        this.perioddata.sourcedata.online = "0";
        this.perioddata.sourcedata.price.method = this.perioddata.price.method;
        this.perioddata.sourcedata.price.price = this.perioddata.price.price;
      } else {
        this.thdata.period.push({
          code: this.perioddata.code,
          pre: this.perioddata.pre,
          name: this.perioddata.name,
          startdate: this.perioddata.starttime,
          enddate: this.perioddata.endtime,
          remark: this.perioddata.remark,
          order: this.perioddata.order,
          online: "0",
          price: {
            method: this.perioddata.price.method,
            price: this.perioddata.price.price
          }
        });
      }
      this.periodOpenClose();
    },
    periodOpenClose() {
      this.perioddata = {
        starttime: this.$moment(),
        throughtdate: 30,
        endtime: this.$moment().add(1, "months"),
        code: "",
        pre: "",
        name: "",
        price: {
          method: "discash",
          price: ""
        },
        remark: "",
        order: ""
      }
    },
    openperiod(method, data = {}) {
      //insSpecification 有引用
      this.periodOpen.open = true;
      this.periodOpen.method = method;
      if (method == "insert") {
        this.perioddata = {
          starttime: this.$moment(),
          throughtdate: 30,
          endtime: this.$moment().add(1, "months"),
          code: "",
          pre: "",
          name: "",
          price: {
            method: "discash",
            price: ""
          },
          remark: "",
          order: ""
        };
      } else if (method == "update") {
        this.perioddata = {
          starttime: this.$moment(data.startdate),
          throughtdate: this.$moment(data.enddate).diff(this.$moment(data.startdate), "days"),
          endtime: this.$moment(data.enddate),
          code: data.code,
          pre: data.pre,
          name: data.name,
          price: {
            method: data.price.method,
            price: data.price.price
          },
          remark: data.remark,
          uid: data.uid,
          order: data.order,
          sourcedata: data
        };
      }
    },
    allcheckbox(source, list, event) {
      // _.map(list,)
      const node = source.split(".");
      const ts = _.reduce(node, (currey, item, keys) => {
        return currey[item];
      }, this.thdata);
      if (event.target.checked) {
        ts.length = 0;
        _.each(list, (item, keys) => {
          ts.push(item.value);
        })
      } else {
        _.each(ts, (item, keys) => {
          ts.splice(0, 1);
        })
      }
      return;
    },
    changeT(name, value, parsent = "", node = "") {
      if (parsent) {
        if (node) {
          this[parsent][node][name] = value;
        } else {
          this[parsent][name] = value;
        }
      } else {
        this[name] = value;
      }
    },
    changeinput(name, value, node = "") {
      if (node) {
        this.thdata[node][name] = value;
      } else {
        this.thdata[name] = value;
      }
    },
    changeinputpush(name, value, node = "") {
      let tmp = null;
      if (node) {
        tmp = this.thdata[node][name];
      } else {
        tmp = this.thdata[name];
      }
      if (tmp.indexOf(value) > -1) {
        tmp.splice(tmp.indexOf(value), 1);
      } else {
        tmp.push(value);
      };
    },
    saveperiod(data) {
      console.log(data);
    }
  },
  computed: {
  
    getListname() {
      return (data, where) => {
        const st = filter.filter(data, where);
        return st[0].name;
      }
    },
    getListdata() {
      return (data, where) => {
        const st = filter.filter(data, where);
        return st[0]
      }
    },
    computemoney() {
      return (a, b, comput = '+') => {
        let sum = 0;
        switch (comput) {
          case "+":
            sum = a + b;
            break;
          case "-":
            sum = a - b;
            break;
          case "*":
            sum = a * b;
            break;
          case "%":
            sum = a * (b / 100);
            break;
        }
        return sum;
      }
    },
    getthroughtdate: {
      get() {
        return this.perioddata.throughtdate;
      },
      set(data) {
        this.perioddata.endtime = this.perioddata.starttime.clone().add(data, "days");
      },
    },
    getperindStart: {
      get() {
        return new Date(this.perioddata.starttime.format("YYYY/MM/DD"));
      },
      set(data) {
        this.perioddata.starttime = this.$moment(data);
        this.perioddata.endtime = this.perioddata.starttime.clone().add(this.perioddata
          .throughtdate, "days");
      }
    },
    baseData() {
      return this.data['insBaseField'];
    },
    thdata() {
      return this.data[this.pagename];
    }
  },
  props: {
    data: Object,
    pagename: String
  },
    components: {
      betweenPrice
    }
};
